import { render, staticRenderFns } from "./SeeNews.vue?vue&type=template&id=46b18124&scoped=true"
import script from "./SeeNews.vue?vue&type=script&lang=js"
export * from "./SeeNews.vue?vue&type=script&lang=js"
import style0 from "./SeeNews.vue?vue&type=style&index=0&id=46b18124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b18124",
  null
  
)

export default component.exports